import { useContext, useEffect, useState, useRef } from 'react';
import ContextStates from '../context/ContextStates';
import axios from 'axios';
import ReactToPrint from 'react-to-print';
import { FaPrint, FaMoneyBillWave, FaCreditCard, FaExchangeAlt, FaBriefcase, FaCoins, FaWallet, FaUserPlus, FaInfoCircle, FaSpinner, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa'
import { Url } from './Url';
import Select from 'react-select';
import jsPDF from 'jspdf'

const getPaymentIcon = (id, desc) => {
    const d = desc.toLowerCase();
    if (d.includes('efectivo')) return <FaMoneyBillWave className="text-xl sm:text-2xl" />;
    if (d.includes('cta') || d.includes('cuenta') || d.includes('corriente')) return <FaBriefcase className="text-xl sm:text-2xl" />;
    if (d.includes('tarjeta') || d.includes('debito') || d.includes('crédito') || d.includes('credito')) return <FaCreditCard className="text-xl sm:text-2xl" />;
    if (d.includes('transferencia') || d.includes('mercado') || d.includes('pago') || d.includes('mp')) return <FaExchangeAlt className="text-xl sm:text-2xl" />;
    if (d.includes('varios') || d.includes('mixto') || d.includes('combinado')) return <FaCoins className="text-xl sm:text-2xl" />;
    return <FaWallet className="text-xl sm:text-2xl" />;
}

const FinalizarVenta = () => {
    const [total, setTotal] = useState(0)
    const [cliente, setCliente] = useState(0)
    const [fecha, setFecha] = useState('')
    const [hora, setHora] = useState('')
    const [nombre, setNombre] = useState('')
    const [razonSocial, setRazonSocial] = useState('')
    const [cuit, setCuit] = useState('')
    const [fechaInicio, setFechaInicio] = useState('')
    const [medios, setMedios] = useState([])
    const [medioPago, setMedioPago] = useState('1')
    const [medio1, setMedio1] = useState('1')
    const [medio2, setMedio2] = useState('4')
    const [importe1, setImporte1] = useState('')
    const [importe2, setImporte2] = useState('')
    const [efectivo, setEfectivo] = useState('')
    const [finalizar, setFinalizar] = useState(true)
    const [procesando, setProcesando] = useState(false)
    const [datosFactura, setDatosFactura] = useState('')
    const [finVenta, setFinVenta] = useState(false)
    const [habilitado, setHabilitado] = useState(true)
    const [auxVenta, setAuxVenta] = useState([])
    const [auxTotal, setAuxTotal] = useState(0)
    const [prestamo, setPrestamo] = useState(false)
    const [envases, setEnvases] = useState([])
    const [envase, setEnvase] = useState(0)
    const [cantidadEnv, setCantidadEnv] = useState("")
    const [listEnvases, setListEnvases] = useState([])
    const [descuentos, setDescuentos] = useState([])
    const [filtro, setFiltro] = useState(false)

    const { venta, tipoPrecio, setVenta, setFormView, setViewOpen, modify, setModify, idUsuario, clientes, setClientes, setFormPrev, puntoVenta, clienteSelected, setClienteSelected } = useContext(ContextStates);
    const componentRef = useRef();
    const [clienteObj, setClienteObj] = useState(null);

    useEffect(() => {
        if (medioPago === '7') {
            console.log("verifica", importe2)
            if (importe1 === '') {
                setFinalizar(false)
            }
            else {
                let aux = 0;
                if (importe1 > total) {
                    setFinalizar(false)
                    setImporte2('')
                }
                else {
                    if (medio1 === '3') {
                        aux = total - importe1 + (importe1 * 0.2);
                    } else {
                        aux = total - importe1;
                        if (medio2 === '3') {
                            aux = aux * 1.2;
                        }
                    }
                    setImporte2(aux)
                    setFinalizar(true)
                }
            }
        }
    }, [medioPago, importe1, medio1, medio2])

    useEffect(() => {
        const calcTotal = () => {
            let aux = 0;
            let rData = [...descuentos]
            venta.forEach(element => {
                if (tipoPrecio === 1) {
                    if (element.tipopromo === '1' || element.tipopromo === '2') {
                        aux = aux + parseFloat(element.preciopromocion * element.cantidad);
                        let montoDesc = parseFloat(element.precio * element.cantidad) - parseFloat(element.preciopromocion * element.cantidad);
                        let descuento = {
                            id: element.id,
                            descripcion: element.descripcion,
                            monto: montoDesc
                        }
                        rData.push(descuento)
                    }
                    else {
                        if (element.tipopromo === '3') {
                            let precio = 0;
                            if (element.cantidad >= element.cantidadminima) {
                                let cantPromos = parseFloat(element.cantidad) / parseFloat(element.cantidadminima);
                                let cantPagos = element.cantidad - (parseFloat(element.cantidaddescuento) * cantPromos);
                                precio = cantPagos * parseFloat(element.precio);
                                let montoDesc = parseFloat(element.precio * element.cantidad) - precio;
                                let descuento = {
                                    id: element.id,
                                    descripcion: element.descripcion,
                                    monto: montoDesc
                                }
                                rData.push(descuento)
                            } else {
                                precio = parseFloat(element.cantidad) * parseFloat(element.precio);
                            }
                            aux = aux + precio;
                        } else {
                            aux = aux + parseFloat(element.precio * element.cantidad);
                        }
                    }
                }
                else {
                    if (tipoPrecio === 2) {
                        aux = aux + parseFloat(element.preciopormayor * element.cantidad);
                    }
                    else {
                        aux = aux + parseFloat(element.preciopormayor2 * element.cantidad);

                    }
                }
            });
            setDescuentos(rData)
            setTotal(aux)
        }
        calcTotal()
    }, [venta])

    useEffect(() => {
        const getMedios = async () => {
            const formData = new FormData()
            try {
                const results = await axios({
                    url: Url + 'api/listmediospago.php',
                    method: 'POST',
                    data: formData,
                })
                setMedios(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getMedios()
    }, [])

    useEffect(() => {
        const consultaClientes = async () => {
            let filt = 0
            if (filtro) {
                filt = 1
            }
            const formData = new FormData()
            formData.append('idusuario', idUsuario)
            formData.append('filtro', filt)
            formData.append('busqueda', "")
            try {
                const response = await axios({
                    url: Url + 'api/listClientes.php',
                    method: 'POST',
                    data: formData,
                })
                setClientes(response.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        consultaClientes()
    }, [modify, filtro])

    useEffect(() => {
        if (clienteSelected && clienteSelected.id) {
            setCliente(clienteSelected.id);
            setClienteObj(clienteSelected);
            setClienteSelected({});
        }
    }, [clienteSelected])

    useEffect(() => {
        const getEnvases = async () => {
            const formData = new FormData()
            //formData.append('idusuario', idUsuario)
            //formData.append('busqueda', "")
            try {
                const response = await axios({
                    url: Url + 'api/getEnvases.php',
                    method: 'POST',
                    data: formData,
                })
                setEnvases(response.data.results);
                setEnvase(response.data.results[0].id)
            } catch (e) {
                console.log(e)
            }
        }
        getEnvases()
    }, [])

    const facturaAfip = async () => {
        if (total > 0 && medioPago === '5') {
            setProcesando(true)
            const formData = new FormData()
            formData.append('total', total);
            try {
                const response = await axios({
                    url: Url + 'api/factura.php',
                    method: 'POST',
                    data: formData,
                })
                setProcesando(false)
                setDatosFactura(response.data.results.cae)
            } catch (e) {
                console.log(e)
            }
        }
    }

    const finalizarVenta = async () => {
        if (medioPago === '6' && cliente === 0) {
            alert("Debe seleccionar un cliente para realizar una venta en Cuenta Corriente.");
            return;
        }
        if (habilitado && finalizar) {
            setHabilitado(false)
            let tPrecio = 0;
            if (tipoPrecio === 2) {
                tPrecio = 1;
            }
            else if (tipoPrecio === 3) {
                if (tipoPrecio === 2) {
                    tPrecio = 2;
                }
            }
            const auxVenta = JSON.stringify(venta)
            const auxEnvases = JSON.stringify(listEnvases)
            const auxDescuentos = JSON.stringify(descuentos)
            const formData = new FormData()
            formData.append('venta', auxVenta);
            formData.append('mediopago', medioPago);
            formData.append('idusuario', idUsuario);
            formData.append('cliente', cliente);
            formData.append('total', total);
            formData.append('puntoventa', puntoVenta);
            formData.append('tipoprecio', tPrecio);
            formData.append('envases', auxEnvases);
            formData.append('descuentos', auxDescuentos);
            formData.append('medio1', medio1);
            formData.append('medio2', medio2);
            formData.append('importe1', importe1);
            try {
                const response = await axios({
                    url: Url + 'api/finVenta.php',
                    'Content-Type': 'application/json',
                    method: 'POST',
                    data: formData,
                    dataType: 'JSON',
                })
                console.log(response)
                setFecha(response.data.results.fecha);
                setHora(response.data.results.hora);
                setNombre(response.data.results.nombre)
                setRazonSocial(response.data.results.razonsocial)
                setCuit(response.data.results.cuit)
                setFechaInicio(response.data.results.fechainicio)
                setAuxVenta(venta)
                setAuxTotal(total)

                setVenta([]);
                setFinVenta(true)

                let aux = modify + 1;
                setModify(aux)
                setDatosFactura('')

            } catch (e) {
                console.log(e)
            }
        }
    }

    const handleSelect = (item) => {
        if (item) {
            setCliente(item.id)
            setClienteObj(item)
        } else {
            setCliente(0)
            setClienteObj(null)
        }
    }

    const handleAdd = () => {
        setFormPrev(2)
        setFormView(30)
    }

    const addEnvase = () => {
        if (cantidadEnv !== '') {
            let rData = [...listEnvases];
            let nombre = "";
            let encontrado = 0;
            envases.forEach(element => {
                if (element.id === envase) {
                    nombre = element.nombre
                }
            });
            rData.forEach(element => {
                if (element.id === envase) {
                    element.cantidad = parseInt(element.cantidad) + parseInt(cantidadEnv);
                    encontrado = 1;
                }
            })
            if (encontrado === 0) {
                rData.push({
                    id: envase,
                    nombre,
                    cantidad: cantidadEnv,
                })
            }
            setListEnvases(rData)
            setCantidadEnv("")
        }
    }
    const quitEnvases = (envase) => {
        let rData = [...listEnvases];
        let rAux = [];
        rData.forEach(element => {
            if (element.id !== envase.id) {
                rAux.push(element)
            }
        });
        setListEnvases(rAux);
    }

    const calcTotal = (item) => {
        let precio = 0;
        if (item.cantidad >= item.cantidadminima) {
            let cantPromos = parseFloat(item.cantidad) / parseFloat(item.cantidadminima);
            let cantPagos = item.cantidad - (parseFloat(item.cantidaddescuento) * cantPromos);
            precio = cantPagos * parseFloat(item.precio);
        } else {
            precio = parseFloat(item.cantidad) * parseFloat(item.precio);
        }
        return (precio.toLocaleString("es-AR", { maximumFractionDigits: 2 }));
    }


    return (
        <div className="w-full mx-auto">
            {!finVenta ? (
                <div className='w-full sm:w-11/12 mx-auto py-2'>
                    <div className='w-full mx-auto mb-6'>
                        <div className='bg-gradient-to-r from-slate-900 to-indigo-950 p-6 rounded-2xl shadow-lg border border-slate-800 text-center flex flex-col justify-center items-center'>
                            <span className='text-xs font-semibold text-indigo-300 uppercase tracking-widest mb-1'>Total a Cobrar</span>
                            <p className='text-white text-4xl sm:text-5xl font-black tracking-tight'>
                                ${parseFloat(total).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                        </div>
                    </div>

                    <div className='w-full flex flex-col md:flex-row gap-6'>
                        <div className='bg-white border border-gray-100 rounded-2xl p-5 shadow-sm md:w-1/2 flex flex-col gap-4'>
                            <h3 className='text-lg font-bold text-gray-800 uppercase tracking-wider mb-2 border-b border-gray-100 pb-2 flex items-center gap-2'>
                                Método de Pago
                            </h3>
                            <div className='grid grid-cols-1 gap-3'>
                                {typeof medios !== 'undefined' && medios.map((item, index) => {
                                    const isActive = medioPago === item.id;
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => setMedioPago(item.id)}
                                            className={`flex items-center gap-4 p-4 rounded-xl border-2 cursor-pointer transition-all duration-200 ${isActive
                                                    ? 'border-indigo-600 bg-indigo-50/40 text-indigo-900 ring-4 ring-indigo-50 shadow-sm'
                                                    : 'border-gray-100 hover:border-gray-200 hover:bg-slate-50/50 text-gray-600'
                                                }`}
                                        >
                                            <div className={`p-2.5 rounded-lg ${isActive ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-gray-400'}`}>
                                                {getPaymentIcon(item.id, item.descripcion)}
                                            </div>
                                            <div className='flex-grow'>
                                                <p className={`font-bold text-sm ${isActive ? 'text-indigo-900' : 'text-gray-700'}`}>{item.descripcion}</p>
                                            </div>
                                            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${isActive ? 'border-indigo-600 bg-indigo-600' : 'border-gray-300'}`}>
                                                {isActive && <div className='w-2 h-2 rounded-full bg-white' />}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        <div className='bg-white border border-gray-100 rounded-2xl p-5 shadow-sm md:w-1/2 flex flex-col justify-between gap-6'>
                            <div>
                                <h3 className='text-lg font-bold text-gray-800 uppercase tracking-wider mb-2 border-b border-gray-100 pb-2'>
                                    Cliente
                                </h3>
                                <label className="w-full flex items-center gap-2 text-sm text-gray-500 font-semibold cursor-pointer mb-4 select-none">
                                    <input
                                        className='rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 w-4 h-4'
                                        type='checkbox'
                                        onChange={() => setFiltro(!filtro)}
                                        checked={filtro}
                                    />
                                    Solo Clientes asociados a mi usuario
                                </label>
                                <div className="w-full mb-4">
                                    <Select
                                        options={clientes}
                                        value={clienteObj}
                                        placeholder="Seleccione Cliente (Opcional)"
                                        onChange={(value) => handleSelect(value)}
                                        name='sCliente'
                                        isClearable={true}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                borderRadius: '12px',
                                                padding: '3px',
                                                borderColor: '#e2e8f0',
                                                '&:hover': { borderColor: '#cbd5e1' }
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                            <div>
                                <button
                                    type='button'
                                    className='w-full flex items-center justify-center gap-2 p-3.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 font-bold rounded-xl transition-all duration-200 text-xs uppercase tracking-wide shadow-sm'
                                    onClick={() => handleAdd()}
                                >
                                    <FaUserPlus className="text-base" />
                                    Agregar Nuevo Cliente
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className='w-full'>
                        {medioPago === '1' && (
                            <div className='w-full mt-6 bg-indigo-50/50 border border-indigo-100 rounded-2xl p-6 flex flex-col sm:flex-row items-center gap-6'>
                                <div className="w-full sm:w-1/2">
                                    <label className="block text-xs font-bold text-indigo-900 uppercase tracking-wider mb-2" htmlFor='efectivo'>Monto Recibido (Efectivo)</label>
                                    <div className="relative">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-4 text-indigo-400 font-bold text-lg">$</span>
                                        <input
                                            type='number'
                                            className='pl-8 pr-4 py-3 w-full rounded-xl border border-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-500 font-bold text-lg shadow-sm text-gray-800'
                                            value={efectivo}
                                            id="efectivo"
                                            onChange={(e) => setEfectivo(e.target.value)}
                                            autoFocus
                                        />
                                    </div>
                                </div>
                                <div className="w-full sm:w-1/2 text-center sm:text-right">
                                    <p className='text-xs font-bold text-indigo-900 uppercase tracking-wider mb-1'>Cambio / Vuelto</p>
                                    <div className={`p-4 rounded-xl border inline-block min-w-[200px] text-center ${efectivo >= total ? 'bg-emerald-50 text-emerald-800 border-emerald-100 font-black text-3xl' : 'bg-slate-50 text-slate-400 border-slate-100 font-bold text-lg'}`}>
                                        {efectivo >= total ? `$${parseFloat(efectivo - total).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'Monto insuficiente'}
                                    </div>
                                </div>
                            </div>
                        )}
                        {medioPago === '5' && (
                            <div className='w-full mt-6 bg-slate-50 border border-gray-100 rounded-2xl p-6'>
                                <div className="sm:items-start">
                                    {datosFactura !== '' ? (
                                        <div className='bg-emerald-50 text-emerald-800 border border-emerald-200 rounded-xl p-4 flex items-center gap-3'>
                                            <FaCheckCircle className='text-xl flex-shrink-0' />
                                            <p className='font-semibold text-sm'>Se ha generado la factura con CAE: <span className='font-mono font-bold'>{datosFactura}</span></p>
                                        </div>
                                    ) : (
                                        !procesando ? (
                                            <button type='button'
                                                className='w-full flex items-center justify-center gap-2 p-3.5 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white uppercase font-bold rounded-xl transition-all shadow-sm text-xs tracking-wide'
                                                onClick={() => facturaAfip()}
                                            >
                                                Generar Factura Electrónica
                                            </button>
                                        ) : (
                                            <div className='bg-indigo-50 border border-indigo-100 text-indigo-700 rounded-xl p-4 flex items-center gap-3 justify-center'>
                                                <FaSpinner className='animate-spin text-xl' />
                                                <p className='font-semibold text-sm'>Generando factura electrónica, por favor aguarde...</p>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        )}
                        {medioPago === '6' && (
                            <div className='w-full mt-6 bg-amber-50 border border-amber-200 text-amber-800 rounded-2xl p-5 flex items-start gap-3'>
                                <FaInfoCircle className="text-xl mt-0.5 flex-shrink-0 text-amber-600" />
                                <div className='text-sm font-semibold text-left'>
                                    <p className='font-bold text-amber-900'>Venta en Cuenta Corriente</p>
                                    <p className='mt-1 text-xs text-amber-700 font-medium'>Se requiere asociar la venta a un cliente. El importe total de la venta se cargará como saldo deudor en su ficha.</p>
                                </div>
                            </div>
                        )}
                        {medioPago === '7' && (
                            <div className='w-full mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6'>
                                <div className='bg-slate-50 border border-slate-100 rounded-2xl p-5'>
                                    <p className='text-xs font-bold text-slate-500 uppercase tracking-wider mb-4 border-b border-slate-200/50 pb-2'>Medio de Pago 1</p>
                                    <div className="flex flex-col gap-4">
                                        {typeof medios !== 'undefined' && medios.map((item, index) =>
                                            item.id === '1' &&
                                            <label key={index} className="flex items-center gap-3 font-semibold text-sm text-gray-700 cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name="medioPago1"
                                                    value={item.id}
                                                    checked={medio1 === item.id}
                                                    onChange={() => setMedio1(item.id)}
                                                    className='rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 w-4 h-4'
                                                />
                                                {item.descripcion}
                                            </label>
                                        )}
                                        <div>
                                            <label className="block text-xs font-bold text-gray-500 uppercase mb-2 text-left" htmlFor='importe1'>Importe 1</label>
                                            <div className="relative">
                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3.5 text-gray-400 font-bold">$</span>
                                                <input
                                                    type='text'
                                                    className={`pl-8 pr-4 py-2.5 w-full rounded-xl border focus:outline-none focus:ring-2 focus:ring-indigo-100 transition-all font-semibold ${importe1 > total ? 'border-red-300 bg-red-50 text-red-900' : 'border-gray-200 bg-white text-gray-800'}`}
                                                    value={importe1}
                                                    id="importe1"
                                                    onChange={(e) => setImporte1(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='bg-slate-50 border border-slate-100 rounded-2xl p-5'>
                                    <p className='text-xs font-bold text-slate-500 uppercase tracking-wider mb-4 border-b border-slate-200/50 pb-2'>Medio de Pago 2</p>
                                    <div className="flex flex-col gap-4">
                                        {typeof medios !== 'undefined' && medios.map((item, index) =>
                                            item.id === '4' &&
                                            <label key={index} className="flex items-center gap-3 font-semibold text-sm text-gray-700 cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name="medioPago2"
                                                    value={item.id}
                                                    checked={medio2 === item.id}
                                                    onChange={() => setMedio2(item.id)}
                                                    className='rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 w-4 h-4'
                                                />
                                                {item.descripcion}
                                            </label>
                                        )}
                                        <div>
                                            <label className="block text-xs font-bold text-gray-500 uppercase mb-2 text-left" htmlFor='importe2'>Importe 2</label>
                                            <div className="relative">
                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3.5 text-gray-400 font-bold">$</span>
                                                <input
                                                    type='text'
                                                    className='pl-8 pr-4 py-2.5 w-full rounded-xl border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-100 transition-all font-semibold text-gray-800'
                                                    value={importe2}
                                                    id="importe2"
                                                    onChange={(e) => setImporte2(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='w-full mt-8 flex justify-center'>
                        <button
                            type='button'
                            className={`w-full sm:w-1/2 p-4 text-white uppercase font-bold rounded-xl transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-2 ${habilitado && finalizar
                                    ? 'bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 cursor-pointer'
                                    : 'bg-slate-200 text-slate-400 cursor-not-allowed border border-slate-300'
                                }`}
                            onClick={() => finalizarVenta()}
                            disabled={!habilitado || !finalizar}
                        >
                            {!habilitado ? (
                                <>
                                    <FaSpinner className='animate-spin text-lg' />
                                    Aguarde un instante por favor...
                                </>
                            ) : (
                                <>
                                    <FaCheckCircle className="text-lg" />
                                    Finalizar venta
                                </>
                            )}
                        </button>
                    </div>
                </div>

            ) : (
                <div className='w-10/12 mx-auto'>
                    <div className='print:px-4 print:text-sm print:h-svh' ref={componentRef}>
                        <div className='w-full mx-auto'>
                            <p className='text-center text-2xl font-bold print:text-xl'>{nombre}</p>
                            <p className='text-left print:pl-2 rounded-lg text-xl print:text-sm'>{`Razón Social: ${razonSocial}`}</p>

                            <p className='text-left print:pl-2 rounded-lg text-xl print:text-sm'>{`Inicio de Act.: ${fechaInicio}`}</p>
                            <div className='w-full mt-3 mb-7'>
                                <div className='w-full print:pl-2'>
                                    <p className='text-left'>Fecha {fecha}</p>
                                </div>
                                <div className='w-full print:pl-2'>
                                    <p className='text-left'>Hora {hora}</p>
                                </div>
                                {clienteObj && (
                                    <div className='w-full print:pl-2 mt-3 pt-3 border-t border-gray-200'>
                                        <p className='text-left print:text-sm font-bold'>{`Cliente: ${clienteObj.apellido}, ${clienteObj.nombre}`}</p>
                                        {clienteObj.cuit && <p className='text-left print:text-sm'>{`CUIT: ${clienteObj.cuit}`}</p>}
                                        {clienteObj.domicilio && <p className='text-left print:text-sm'>{`Domicilio: ${clienteObj.domicilio}`}</p>}
                                    </div>
                                )}
                            </div>
                        </div>
                        {typeof auxVenta !== 'undefined' && auxVenta.map((item, index) => (
                            <div key={index} className='w-full flex'>
                                <div className='w-full print:pl-2 print:pr-10'>
                                    <p className='text-left print:text-sm'>{`${parseFloat(item.cantidad).toFixed(2)} x  ${item.descripcion}`}</p>
                                </div>
                                <div className='w-full print:pr-10'>
                                    <p className='text-right print:text-sm'>P.U ${tipoPrecio === 2 ? parseFloat(item.preciopormayor).toLocaleString("es-AR", { maximumFractionDigits: 2 }) : tipoPrecio === 3 ? parseFloat(item.preciopormayor2).toLocaleString("es-AR", { maximumFractionDigits: 2 }) : item.tipopromo === '3' ? calcTotal(item) : (item.tipopromo === '1' || item.tipopromo === '2') ? parseFloat(item.preciopromocion).toLocaleString("es-AR", { maximumFractionDigits: 2 }) : parseFloat(item.precio).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                </div>
                                <div className='w-full print:pr-10'>
                                    <p className='text-right print:text-sm'>${tipoPrecio === 2 ? (parseFloat(item.preciopormayor) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 }) : tipoPrecio === 3 ? (parseFloat(item.preciopormayor2) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 }) : item.tipopromo === '3' ? calcTotal(item) : (item.tipopromo === '1' || item.tipopromo === '2') ? (parseFloat(item.preciopromocion) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 }) : (parseFloat(item.precio) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                </div>
                            </div>
                        ))}
                        <div className='w-full print:pl-2'>
                            <p className='text-left font-bold uppercase text-3xl print:text-base'>Total</p>
                        </div>
                        <div className='w-full print:pr-10'>
                            <p className='text-right font-bold uppercase text-3xl print:text-base'>${parseFloat(auxTotal).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                        </div>
                        {typeof descuentos !== 'undefined' && descuentos.length > 0 && (
                            <div className='w-full print:pl-2'>
                                <p className='text-left font-bold uppercase text-3xl print:text-base'>Descuentos</p>
                            </div>
                        )}
                        {typeof descuentos !== 'undefined' && descuentos.map((item, index) => (
                            <div key={index} className='w-full'>
                                <div className='w-full print:pl-2 print:pr-10'>
                                    <p className='text-left print:text-sm'>{`${item.descripcion}`}</p>
                                </div>
                                <div className='w-full print:pr-10'>
                                    <p className='text-right print:text-sm'>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className="w-full rounded-lg px-3 flex justify-center pb-5">
                        <ReactToPrint
                            trigger={() =>
                                <button
                                    type="button"
                                    className="w-2/3 sm:w-1/4 flex shadow-md p-3 ml-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                                >
                                    <FaPrint className='mx-auto mt-1' />
                                    <p className='mx-auto text-center'>
                                        Imprimir Comprobante
                                    </p>
                                </button>}
                            content={() => componentRef.current}
                        />
                        <button
                            type="button"
                            className="w-1/3 sm:w-1/6 shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                            onClick={() => setViewOpen(false)}
                        >
                            Salir
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default FinalizarVenta